import React from 'react';

const Caterereglobal = () => (
    <div className="copyright" style={{ margin: '50px 0' }}>
        <div className="container">
            <div className="row">
                <div className="col-xs-12 content">
                    <div className="footer-container">
                        <ul className="list-inline footer">
                            <li className="first">
                                <a
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href="https://www.catererglobal.com/reference/about-us"
                                >
                                    About us
                                </a>
                            </li>
                            <li>
                                <a
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href="https://www.catererglobal.com/reference/privacy-policy"
                                >
                                    Privacy policy
                                </a>
                            </li>
                            <li>
                                <a
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href="https://www.catererglobal.com/reference/cookies-policy"
                                >
                                    Cookies policy
                                </a>
                            </li>
                            <li>
                                <a
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href="https://www.catererglobal.com/reference/terms-and-conditions"
                                >
                                    Terms and Conditions
                                </a>
                            </li>
                            <li>
                                <a target="_blank" rel="noopener noreferrer" href="https://www.totaljobsgroup.com/">
                                    Work for us
                                </a>
                            </li>
                            <li>
                                <a
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href="https://www.catererglobal.com/hotel-openings/"
                                >
                                    New openings
                                </a>
                            </li>
                            <li>
                                <a
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href="https://www.catererglobal.com/about/partners/"
                                >
                                    Partners
                                </a>
                            </li>
                        </ul>
                    </div>
                    <span>© Copyright and database rights Totaljobs Group Ltd 2019</span>
                    <br />
                    <a
                        target="_blank"
                        rel="noopener noreferrer"
                        title="Totaljobs Group"
                        href="https://www.totaljobsgroup.com"
                        className="tjglogo"
                        style={{ display: 'block', margin: '0 auto' }}
                    >
                        &nbsp;
                    </a>
                </div>
            </div>
        </div>
    </div>
);

export default Caterereglobal;
